/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Dish from '@/model/dataLayer/api/dish/Dish'
import Category from '@/model/dataLayer/api/dish/Category'
import { keyBy } from 'lodash-es'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'
import { syncData } from '@/model/dataLayer/api/takeaway/TakeawayManager'

const entity = {

  code: {
    tableConfig: {
      width: '160'
    }
  },
  name: {},
  dishesCategoryId: {
    // displayName: 'consumeTypeId',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Category.getList,
        itemText: '_langsname'
      }
    }
  },
  dishesCategoryTypeId: {
    displayName: 'TaxRate',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          const res = (await CategoryType.getList(true))
          res.forEach(it => {
            it.name = it._langsname
          })
          return res
        },
        itemText: 'name'
      }
    }
  },
  showing: {
    type: IKDataEntity.Types.Boolean
  },
  isFree: {
    type: IKDataEntity.Types.Boolean
  },
  isGiveaway: {
    type: IKDataEntity.Types.Boolean
  }

}

let counter = 0
const config = {
  edit: async function (item) {
    const request = []
    request.push(hillo.post('Dishes.php', item, {
      params: {
        op: (item.showing ? 'enable' : 'disable') + 'SingleDishShowInConsumeType'
      }
    }))
    request.push(hillo.post('Dishes.php', item, {
      params: {
        op: (item.isFree ? 'enable' : 'disable') + 'SingleDishFreeInConsumeType'
      }
    }))
    request.push(hillo.post('Dishes.php', item, {
      params: {
        op: (item.isGiveaway ? 'enable' : 'disable') + 'SingleDishGiveawayInConsumeType'
      }
    }))
    await Promise.all(request)
    if (item.consumeTypeId === '5') {
      try {
        await syncData()
      } catch (e) {
        console.log(e, 'error')
      }
    }
  },

  load: async function (filter) {
    const dishDict = keyBy(await Dish.getList(true), 'id')
    const currentList = [];
    ((await hillo.get('Dishes.php?op=showDishesShowAndFreeByConsumeType',
      ...filter
    ))
      .content).map(d => {
      d.id = counter
      d.name = dishDict[d.dishId]?.dishName
      counter++
      if (dishDict[d.dishId]) {
        currentList.push(d)
      }
      return d
    })
    return currentList
  },
  nameBuilder: function (item) {
    return item.code + '.' + item.optdishId[0]
  }
}

export default IKDataEntity.ModelFactory(entity, config)
